import { errorExchange } from 'urql';
import { GraphQLError } from 'graphql/index';

const errorStatuses = [404, 403];
const errorStatus = (error: GraphQLError) => error.extensions.status as number;

export const passThroughErrorStatus = () =>
  errorExchange({
    onError: error => {
      if (error.graphQLErrors) {
        const status = errorStatus(error.graphQLErrors[0]);
        if (status && errorStatuses.includes(status)) {
          // Don't throw for codes in errorStatuses - let them flow through to result.error
          return;
        }
      }
      // Throw for all other errors (anything not in errorStatuses)
      throw new Error(`GraphQL Error: ${error.message}`);
    },
  });
